import type { Locale } from "../Locale.js";
import type { Product, ProductAttributeGroupOfValue, ProductForCustomer, ProductVariant } from "../Product.js";
import type { Subcategory } from "../Subcategory.js";
import { getSubcategoryPath } from "./getSubcategoryPath.js";

export function getProductDetailPath(
	locale: Locale,
	product: Pick<Product | ProductForCustomer, "urlSlug" | "variants" | "attributeGroups">,
	subcategory: Pick<Subcategory, "useCustomUrlSlug" | "category" | "urlSlug">,
	variant: Pick<ProductVariant, "id"> | null,
	attributes: Pick<ProductAttributeGroupOfValue, "id" | "value">[],
): string {
	const path = `${getSubcategoryPath(locale, subcategory)}/${product.urlSlug[locale]}`;
	const queryParams = new URLSearchParams();

	const [defaultVariant] = product.variants;
	if (variant && variant.id !== defaultVariant?.id) {
		queryParams.append("variant", variant.id);
	}

	for (const attribute of attributes) {
		const {
			id: groupId,
			value: { id: valueId },
		} = attribute;

		const group = product.attributeGroups.find(({ id }) => id === groupId);
		const [defaultValue] = group?.values ?? [];
		if (valueId !== defaultValue?.id) {
			queryParams.append(`attribute-${groupId}`, valueId);
		}
	}
	const queryString = queryParams.toString();

	return `${path}${queryString ? `?${queryString}` : ""}`;
}
